// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".organisation[data-v-97b7202c]{position:relative}.organisation[data-v-97b7202c],.organisation .rectangle[data-v-97b7202c]{height:32px;width:32px}.organisation .profile[data-v-97b7202c]{height:20px;left:20px;position:absolute;top:16px;width:20px}.organisation .profile img[data-v-97b7202c]{border-radius:50%;height:100%;width:100%}.organisation .profile .avatar[data-v-97b7202c]{height:20px;width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
